import { observable } from "mobx";
import Model from "@app/state/model/base";

export default class PatientProblemReport extends Model {
    @observable _id = undefined;
    @observable patientProblems = [];
    @observable endDate = undefined;
    @observable productCode = undefined;
    @observable startDate = undefined;
    @observable totalEventCount = undefined;
}
